import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Mail, ArrowLeft, Send, Leaf } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Se o email existir, o link foi enviado.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[var(--bone)] grid place-items-center p-6">
      <div className="w-full max-w-md">
        <Link to="/login" className="pill-btn pill-ghost !py-2 !px-3 w-fit" data-testid="back-to-login">
          <ArrowLeft className="w-4 h-4"/> Voltar
        </Link>
        <div className="mt-6 flex items-center gap-3">
          <div className="w-11 h-11 rounded-2xl bg-[var(--forest)] text-white grid place-items-center"><Leaf className="w-5 h-5"/></div>
          <div>
            <div className="font-heading text-lg text-[var(--forest)]">CARING</div>
            <div className="eyebrow -mt-0.5">Referências</div>
          </div>
        </div>
        <div className="eyebrow mt-8">Palavra-passe</div>
        <h1 className="font-heading text-4xl mt-2">Repor palavra-passe</h1>
        <p className="text-[var(--ink-soft)] mt-2">Envie-lhe-emos um link seguro para escolher uma nova palavra-passe. O link é válido durante 45 minutos.</p>

        {sent ? (
          <div className="card-surface p-6 mt-6 space-y-3">
            <div className="chip chip-green w-fit"><Send className="w-3 h-3"/> Email enviado</div>
            <p className="text-sm text-[var(--ink-soft)]">Se existir uma conta com o email <strong>{email}</strong>, receberá o link em segundos. Verifique também o spam.</p>
            <button onClick={() => navigate("/login")} className="pill-btn pill-primary mt-3" data-testid="back-to-login-btn">Voltar ao login</button>
          </div>
        ) : (
          <form onSubmit={submit} className="card-surface p-6 mt-6 space-y-4">
            <div>
              <label className="text-sm font-medium">Email da conta</label>
              <div className="mt-1.5 relative">
                <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[var(--ink-soft)]"/>
                <input
                  type="email"
                  data-testid="forgot-email-input"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="voce@exemplo.pt"
                  className="w-full pl-10 pr-3 py-3 rounded-xl bg-[var(--muted)] border border-[var(--border)] focus:outline-none focus:ring-2 focus:ring-[var(--forest)]"
                />
              </div>
            </div>
            <button disabled={busy} className="pill-btn pill-primary w-full justify-center" data-testid="forgot-submit-btn">
              {busy ? "A enviar…" : "Enviar link"} <Send className="w-4 h-4"/>
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
